export default __webpack_public_path__ + "static/form-multiple-action-buttons-do-3a24bcf8f00f8547d6bc6712653d4a46.png";